import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface UpdateOTCPrescriptionParams {
  freetextMedicationDetails: string;
}

interface UpdateOTCPrescriptionResponse {
  bundle: object;
}

export const useUpdateOTCPrescription = ({
  patientId,
  encounterId,
  carePlanId,
  carePlanActivityId,
}: {
  patientId: string;
  encounterId: string;
  carePlanId: string;
  carePlanActivityId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    UpdateOTCPrescriptionResponse,
    UpdateOTCPrescriptionParams
  >({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Prescriptions.UPDATE_OTC(
        patientId,
        encounterId,
        carePlanActivityId,
      ),
      mutationFn: (params) => {
        return axiosInstance.patch(
          `/rx/prescriptions/otc/${carePlanActivityId}`,
          params,
          {
            params: {
              care_plan_id: carePlanId,
            },
          },
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Prescriptions.DEFAULT(
            patientId,
            encounterId,
          ),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
